import React from "react";
import { ArrowLeft } from "lucide-react";

const DisclaimerPage = ({ onBack }) => {
  return (
    <div className="min-h-screen bg-black text-white">
      {/* Header */}
      <header className="dark-header">
        <div className="flex items-center">
          <button 
            onClick={onBack}
            className="flex items-center gap-2 btn-secondary mr-4"
          >
            <ArrowLeft size={20} />
            Back
          </button>
          <img 
            src="https://customer-assets.emergentagent.com/job_telegramcrypto/artifacts/c1vqzvr8_final%20logo%20TG4Crypto%20black%202.png"
            alt="TG4Crypto"
            className="h-10 w-auto"
            style={{ 
              filter: 'brightness(0) saturate(100%) invert(70%) sepia(89%) saturate(2873%) hue-rotate(140deg) brightness(104%) contrast(101%)'
            }}
          />
        </div>
      </header>

      {/* Content */}
      <main className="pt-32 pb-20 px-4">
        <div className="max-w-4xl mx-auto">
          <h1 className="display-large mb-12 text-center">Disclaimer</h1>
          
          <div 
            className="p-8 border border-gray-800 rounded-lg"
            style={{
              background: 'rgba(18, 18, 18, 0.8)',
              borderColor: 'var(--border-subtle)'
            }}
          >
            <div className="space-y-6 body-medium leading-relaxed">
              <p>
                Our Telegram setup services are provided as a one-time professional setup based on the specifications agreed upon at the time of purchase. Upon delivery and completion of the service, all responsibility for the management, security, maintenance, and overall operation of the Telegram group or channel is transferred to the client.
              </p>
              
              <p>
                We value client privacy and guarantee that any sensitive information shared with us will be handled with the utmost confidentiality. Contract addresses or similar sensitive data will only be requested once they are publicly available. Customer satisfaction and service quality remain our highest priorities throughout the entire setup process.
              </p>
              
              <p>
                We do not hold any liability for events, issues, or damages that may occur after the service has been delivered. This includes, but is not limited to, unauthorized access, administrative errors, bot malfunctions, user conflicts, moderation problems, content posted by members, or any form of community mismanagement after the handover.
              </p>
              
              <p>
                It is the client's sole responsibility to maintain, monitor, and secure their Telegram group following the completion of the setup. Any modifications made by the client or third parties after delivery are outside the scope of our responsibility or warranty.
              </p>
              
              <p>
                We are an independent service provider and are not affiliated, associated, authorized, endorsed by, or in any way officially connected with Telegram or any of its subsidiaries or affiliates.
              </p>
              
              <p className="font-bold">
                By purchasing and using our services, the client acknowledges and agrees to these terms and accepts full responsibility for the ongoing management of their Telegram group.
              </p>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default DisclaimerPage;